import { BASE_URL, request } from "./api";
import type { ReferenceType } from "./types";

// GET /api/ReferenceTypes
export const getReferenceTypes = async (): Promise<ReferenceType[]> => {
  return request<ReferenceType[]>(`${BASE_URL}/api/ReferenceTypes`, {
    method: "GET",
  });
};

// POST /api/ReferenceTypes
export const createReferenceType = async (
  referenceType: ReferenceType
): Promise<ReferenceType> => {
  return request<ReferenceType>(`${BASE_URL}/api/ReferenceTypes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: referenceType,
  });
};

// GET /api/ReferenceTypes/{id}
export const getReferenceType = async (id: number): Promise<ReferenceType> => {
  return request<ReferenceType>(`${BASE_URL}/api/ReferenceTypes/${id}`, {
    method: "GET",
  });
};

